import {
  ShieldCheck, Hand, Archive, PencilLine, CircleCheck, TriangleAlert, OctagonAlert, Lock, Wrench, Ban,
  ClipboardList, RefreshCw,
} from "lucide-react";

const S = {
  brouillon: ["En préparation", PencilLine, "border-sky-500/40 bg-sky-950/60 text-sky-200"],
  autorisee: ["Tâche autorisée", ShieldCheck, "border-emerald-400/60 bg-emerald-950/70 text-emerald-200"],
  arretee: ["Travail arrêté", Hand, "border-red-500/80 bg-red-950/80 text-red-100"],
  terminee: ["Tâche terminée", CircleCheck, "border-slate-400/60 bg-slate-800/70 text-slate-100"],
  archivee: ["Archivé", Archive, "border-slate-500/60 bg-slate-800/70 text-slate-200"],
  superseded: ["Remplacé par une révision", RefreshCw, "border-orange-500/60 bg-orange-950/70 text-orange-200"],
  insp_brouillon: ["Inspection en cours", ClipboardList, "border-sky-500/40 bg-sky-950/60 text-sky-200"],
  conforme: ["Conforme", CircleCheck, "border-emerald-500/50 bg-emerald-950/70 text-emerald-200"],
  conforme_avec_anomalies: ["Conforme avec anomalies", TriangleAlert, "border-amber-500/50 bg-amber-950/70 text-amber-200"],
  non_conforme: ["Non conforme", OctagonAlert, "border-red-500 border-2 bg-red-950/80 text-red-100 uppercase"],
  disponible: ["Disponible", CircleCheck, "border-emerald-500/50 bg-emerald-950/70 text-emerald-200"],
  bloque: ["Bloqué", Lock, "border-red-500 border-2 bg-red-950/80 text-red-100 uppercase"],
  maintenance: ["En maintenance", Wrench, "border-amber-500/50 bg-amber-950/70 text-amber-200"],
  hors_service: ["Hors service", Ban, "border-slate-500/60 bg-slate-800/70 text-slate-200"],
  mineure: ["Mineure", TriangleAlert, "border-amber-500/50 bg-amber-950/70 text-amber-200"],
  critique: ["Critique", OctagonAlert, "border-red-500 border-2 bg-red-950/80 text-red-100 uppercase"],
  inactive: ["Désactivé", Ban, "border-slate-500/60 bg-slate-800/70 text-slate-300"],
};

export const StatusBadge = ({ status, testId, size = "sm" }) => {
  const cfg = S[status];
  if (!cfg) return null;
  const [label, Icon, cls] = cfg;
  const pad = size === "lg" ? "px-3 py-1.5 text-sm" : "px-2.5 py-1 text-xs";
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1.5 rounded-md border font-semibold tracking-wide ${pad} ${cls}`}>
      <Icon className={size === "lg" ? "h-4 w-4" : "h-3.5 w-3.5"} aria-hidden="true" />
      {label}
    </span>
  );
};
